import React from 'react';
import { DownloadIcon, SearchIcon } from 'lucide-react';
export function SearchInput({
  value,
  onChange,
  placeholder
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
}) {
  return <label className="relative block" data-id="element-726" data-mp="29wuvdmvwy8x0">
      <span className="sr-only" data-id="element-727" data-mp="29xxj5lxxvv8p">{placeholder}</span>
      <SearchIcon className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-ink-subtle" data-id="element-728" data-mp="2euo1kfx7v2xa" />
      <input type="search" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="h-8 w-56 rounded-md border border-line bg-white pl-8 pr-2.5 text-xs text-ink placeholder:text-ink-subtle focus:border-navy/50 focus:outline-none focus:ring-2 focus:ring-navy/15" data-id="element-729" data-mp="32m1rygbt4ofm" />
    </label>;
}
export function ExportButton({
  onClick
}: {
  onClick: () => void;
}) {
  return <button type="button" onClick={onClick} className="inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-md border border-line bg-white px-2.5 text-xs font-medium text-ink transition-colors duration-150 hover:bg-canvas focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy/30" data-id="element-730" data-mp="3qacm70mzzpux">
      <DownloadIcon className="h-3.5 w-3.5" data-id="element-731" data-mp="a6bw5udozurq" />
      Export CSV
    </button>;
}
export function ToggleSwitch({
  checked,
  onChange,
  label
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
}) {
  return <button type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} className="inline-flex h-8 items-center gap-2 whitespace-nowrap rounded-md px-1 text-xs font-medium text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy/30" data-id="element-732" data-mp="k2x70wce803h">
      <span className={`relative h-4 w-7 rounded-full transition-colors duration-150 ${checked ? 'bg-accent' : 'bg-line-strong'}`} data-id="element-733" data-mp="o3qrffqmmwrm">
        <span className={`absolute top-0.5 h-3 w-3 rounded-full bg-white shadow transition-transform duration-150 ${checked ? 'translate-x-3.5' : 'translate-x-0.5'}`} data-id="element-734" data-mp="2pxgbka6yx0x1" />
      </span>
      {label}
    </button>;
}